import React from 'react';
import { useParams } from 'react-router-dom';
import cn from 'classnames';
import ActionWithModalFactory from '../ActionWithModalFactory/ActionWithModalFactory';
import { buttonTypes, modalTypes } from '../../../constants/factoryTypes';
import { texts } from '../../../constants/texts';
import useFlatsGridState from '../../../hooks/useFlatsGridState';
import useHousingStockState from '../../../hooks/useHousingStockState';
import styles from './FlatActions.module.scss';
import { getQueryKeys } from '../../../queries/queryKeys';
import { useSelector } from 'react-redux';

const FlatActions = ({ className, address }) => {
  const params = useParams();

  const addressId = Number(params.pageTabId);

  const { isAvailable, flatId } =
    useSelector((state) => state.housingStockStore.flatAvailable) || {};

  const showActionModal = flatId === addressId && !!isAvailable;

  const { flatsGridQueryKey } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  const actions = [
    {
      actionType: buttonTypes.simple,
      modalType: modalTypes.tenant,
      actionText: texts.addTenant,
      modalProps: {
        address,
        addressId,
        queryKeys: [flatsGridQueryKey, housingStockQueryKey],
      },
    },
    {
      actionType: buttonTypes.simple,
      modalType: modalTypes.account,
      actionText: texts.addPersonalAccount,
      modalProps: {
        address,
        addressId,
        queryKeys: [getQueryKeys.flatAccounts(addressId), housingStockQueryKey],
      },
    },
  ];

  return (
    <div className={cn(styles.root, className)}>
      {showActionModal && (
        <ActionWithModalFactory
          key={actions[0].modalType}
          {...actions[0]}
        />
      )}
    </div>
  );
};

export default FlatActions;
